import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import user from '../../assets/user.png';
import { useAxios } from '../../utils/hook/useAxios';

/*
 * Styles : mc-account-requests.css (importé par la page qui liste les demandes).
 */

const STATUS = {
  0: { tone: 'warn', icon: 'clock-history', label: 'En attente de confirmation' },
  1: { tone: 'info', icon: 'credit-card', label: 'En attente de paiement' },
  2: { tone: 'danger', icon: 'x-circle-fill', label: 'Réservation annulée' },
  3: { tone: 'ok', icon: 'bag-check-fill', label: 'Réservation confirmée', note: 'payée' },
};

function HistoricVoyageItem({ data }) {
  const [askProlongation, setAskProlongation] = useState({});
  const [hasProlongation, setHasProlongation] = useState(false);

  const axios = useAxios();

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const resp = await axios.get('/askupdateresa/reservation/' + data.reservationId);
        if (resp.data) {
          const sortedData = resp.data;
          setAskProlongation(sortedData);
          if (sortedData.lenght > 0) setHasProlongation(true);
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, [data]);

  if (!data.PaymentIntentId) return null;

  const status = STATUS[data.status];
  const cancelled = data.status === '2';
  const invite = data.Invite;
  const guestName = `${invite?.firstName || ''} ${invite?.lastName || ''}`.trim();

  return (
    <Link to={`/inbox/messages/thread/${data.reservationId}`} className="mc-req-item">
      <img
        src={invite?.profile_url || user}
        alt=""
        className="mc-req-avatar"
        width="56"
        height="56"
        loading="lazy"
      />

      <div className="mc-req-body">
        <p className="mc-req-kicker">
          Location n° {data.reservationId}
          {guestName && ` · ${guestName}`}
        </p>

        <p className="mc-req-title">
          {status ? (
            <span className={`mc-req-badge mc-req-badge--${status.tone}`}>
              <i className={`bi bi-${status.icon}`} aria-hidden="true"></i>
              {status.label}
              {status.note && <span className="fw-normal"> ({status.note})</span>}
            </span>
          ) : (
            <span className="mc-req-badge">Statut inconnu</span>
          )}
        </p>

        <p className="mc-req-meta">
          <span className={cancelled ? 'is-struck' : undefined}>
            <i className="bi bi-calendar3" aria-hidden="true"></i>
            {moment(data.startDate).calendar()} → {moment(data.endDate).calendar()}
          </span>
          {cancelled && <span>Vous avez annulé le {moment(data.updatedAt).calendar()}</span>}
        </p>
      </div>

      <div className="mc-req-side">
        <i className="bi bi-chevron-right mc-req-chevron" aria-hidden="true"></i>
      </div>
    </Link>
  );
}

export default HistoricVoyageItem;
